import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getAssetPath } from '../utils/paths';
import CalendlyButton from './CalendlyButton';
import './Hero.css';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section id="hero" className="hero">
      <div className="container hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">Mary K. Carpenter</h1>
            
            {/* Profile Image Section */}
            <div className="hero-profile-image-section">
              <img 
                src={getAssetPath('profile.jpg')}
                alt="Profile" 
                className="hero-profile-image"
                onError={(e) => {
                  console.error('Image failed to load:', e.target.src);
                  // Try absolute path as fallback
                  e.target.src = '/pronurselegal/profile.jpg';
                }}
              />
            </div>
            
            <p className="hero-subtitle">Critical Care RN, ECMO Specialist, Legal Nurse Consultant, Expert Witness</p>
            <div className="hero-sayings">
              <div className="hero-saying">
                <span className="hero-saying-icon" role="img" aria-label="Patient Safety and Advocacy">🛡️</span>
                <span className="hero-saying-text">Patient Safety and Advocacy</span>
              </div>
              <div className="hero-saying">
                <span className="hero-saying-icon" role="img" aria-label="Evidence-based Critical Care">📊</span>
                <span className="hero-saying-text">Evidence-based Critical Care</span>
              </div>
              <div className="hero-saying">
                <img 
                  src={getAssetPath('heart.png')}
                  alt="Early MCS & Shock Staging Expertise"
                  className="hero-saying-icon"
                  onError={(e) => {
                    console.error('Image failed to load:', e.target.src);
                    // Try absolute path as fallback
                    e.target.src = '/pronurselegal/heart.png';
                  }}
                />
                <span className="hero-saying-text">Early MCS & Shock Staging Expertise</span>
              </div>
              <div className="hero-saying">
                <span className="hero-saying-icon" role="img" aria-label="AI-Driven Medical-Legal Innovation">💻</span>
                <span className="hero-saying-text">AI-Driven Medical-Legal Innovation</span>
              </div>
            </div>
            
            <div className="hero-calendly-button">
              <CalendlyButton />
            </div>
            
            <div className="hero-available-for">
              <div className="available-for-card">
                <h4>Available for:</h4>
                <ul>
                  <li>Per Diem & Travel ICU RN Contracting</li>
                  <li>Adult ECMO Specialist Contracting</li>
                  <li>Legal Nurse Consulting (Medical Chronologies & Merit Reviews)</li>
                  <li>Nurse Expert Witness Services</li>
                </ul>
              </div>
            </div>

            <div className="hero-actions">
              <button
                className="btn btn-secondary"
                onClick={() => navigate('/resume')}
              >
                View Resume
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => navigate('/contact')}
              >
                Get In Touch
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;

